
import { filter } from 'rxjs/operators';
import { Component, OnInit, NgZone} from '@angular/core';
import { Location, LocationStrategy, PathLocationStrategy } from '@angular/common';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { AuthenticationService, UserService, CookieService, MyOrderService, MyCartService, IntroService, ProfileService, PasswordService, SliderService, MessageUploadService } from '../_services/index';
import { User, Slide } from '../_models/index';
import { Idle, DEFAULT_INTERRUPTSOURCES } from '@ng-idle/core';

import { DomSanitizer } from '@angular/platform-browser';

declare var $: any;

@Component({
    selector: 'app-template',
    providers: [Location, { provide: LocationStrategy, useClass: PathLocationStrategy }],
    templateUrl: './template.component.html',
    styleUrls: ['./template.component.css']
})
export class TemplateComponent implements OnInit {
    location: Location;
    links: string[][] = [["home", "nav_desktop_1"], ["package", "nav_desktop_2"], ["summary", "nav_desktop_3"], ["checkout", "nav_desktop_4"], ["null", "null"]]

    home = 'nav-link';
    package = 'nav-link';
    summary = 'nav-link';
    checkout = 'nav-link';
    myorder = 'nav-link';
    //----
    model = new User();
    loginInfo = 'Login';
    userInfo = 'Username';
    loginuser = "";
    loginResponse = "";
    loginFailResponse = "";
    forgotPasswordResponse = "";
    orderData: any;
    currentPath: any = null
    h = "12px";
    cartCount = "0";
    saleName: string;
    saleEmail: string;
    sessionKey: string;
    invoiceStatus: string;
    invoiceOnly: string;
    idleState = 'Not started.';
    timedOut = false;

    newPassword: string;
    newPassword2: string;
    changePasswordSuccess = "";
    changePasswordResponse = "";

    slide = new Slide;

    intro: any;

    bulkLoad = ''
    allowBulk

    prescreen: string;
    allowMsg: string;
    curNewMsg: string;
    sampleMsg: string = '<div style=" border:solid 1px red;"><p style="color:red"><b>System Alert: On Saturday June 03rd, 2023,</b> ERIS system will go under regular maintenance.  ERIS web order form, Xplorer, Mobile app, ERIS Direct and SCRIVA applications will not be available from 9 pm to 11.30 pm EST.  We apologize for any inconvenience caused during this time.</p></div>'
    
    infoContent:any;
    
    constructor(private idle: Idle, private router: Router, private ngZone: NgZone, location: Location, private authenticationService: AuthenticationService,
        private userService: UserService, private cookieService: CookieService, private myorderService: MyOrderService, private myCartService: MyCartService,
        private profileService: ProfileService, private introService: IntroService, private passwordService: PasswordService, private sliderService: SliderService, private route: ActivatedRoute, private sanitizer: DomSanitizer, private messageUploadService: MessageUploadService) {

        idle.setIdle(7200);
        // sets a timeout period of 5 seconds. after 10 seconds of inactivity, the user will be considered timed out.
        idle.setTimeout(7200);
        // sets the default interrupts, in this case, things like clicks, scrolls, touches to the document
        idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
        idle.onIdleEnd.subscribe(() => {
            this.idleState = 'No longer idle.';
        });
        idle.onTimeout.subscribe(() => {

            this.timedOut = true;
            this.idleState = 'Timed out!';

            $("#timeoutModal").modal("show");
            this.cookieService.deleteCookie('customerID');
            this.cookieService.deleteCookie("customerName");
            this.cookieService.deleteCookie("ccompanyName");
            this.cookieService.deleteCookie("companyId");
            this.cookieService.deleteCookie('saleEmail');
            this.cookieService.deleteCookie("saleName");
            this.cookieService.deleteCookie("invoiceStatus");
            this.cookieService.deleteCookie("invoiceOnly");
            this.cookieService.deleteCookie('qid');
            this.cookieService.deleteCookie("bucket");
            this.cookieService.deleteCookie("tchecked");
            this.cookieService.deleteCookie("altEmail");
            this.cookieService.deleteCookie("altInvoice");
            this.cookieService.deleteCookie("orderPin");
            this.cookieService.deleteCookie("loginCountry");
            this.cookieService.clearAll();
        });
        idle.onIdleStart.subscribe(() => this.idleState = 'You\'ve gone idle!');
        idle.onTimeoutWarning.subscribe((countdown) => {
            this.idleState = 'Your session will time out in ' + countdown + ' seconds!';
        });

        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd))
            .subscribe((event: NavigationEnd) => {
                this.ngZone.run(() => {
                    let prevPath = localStorage.getItem('previousRoute');
                    let path = event.url.replace("/", "");
                    if (path == "" || path.indexOf("home") > -1) path = "home";
                    this.currentPath = path
                    for (let link of this.links) {
                        if (path == 'myorder' || path == 'onhold' || path == 'ordersummary') {
                            this[link[0]] = 'nav-link complete';
                            break;
                        } else if (path == 'checkout') {

                            this[this.links[0][0]] = 'nav-link complete';
                            this[this.links[1][0]] = 'nav-link';
                            this[this.links[2][0]] = 'nav-link';
                            $('#main_nav').addClass(this.links[3][1]);
                            this[path] = 'nav-link active';
                            break;
                        } else if (link[0] != path) {
                            this[link[0]] = 'nav-link complete';
                        }

                        else {
                            $('#main_nav').addClass(link[1]);
                            this[path] = 'nav-link active';
                            break;
                        }
                    }

                    localStorage.setItem('previousRoute', path);

                    if (this.cookieService.getCookie("customerID")) {
                        let customerId = this.cookieService.getCookie("customerID");
                        let sessionKey = this.cookieService.getCookie("sessionKey");
                        this.myCartService.getcart(customerId, sessionKey).subscribe(
                            data => {
                                this.cartCount = data.length;
                            }
                        )
                    } else {
                        if (this.currentPath.split('?')[0] == "onholdp") {
                            // if clause
                        } else if (event.url.indexOf('token') > -1) {
                            this.route.queryParams.subscribe(params => {
                                let token = params.token;
                                if (token && token.length > 0) {
                                    $('#myModal').modal('hide');
                                    this.authenticationService.newLogin('', '', token).subscribe(mydata => {
                                        let info = mydata._body;
                                        if (info.indexOf('ERROR') > -1) {
                                            let message = info.split(":");
                                            this.loginFailResponse = message[1];
                                            $('#myModal').modal({
                                                backdrop: 'static',
                                                keyboard: false  // to prevent closing with Esc button (if you want this too)
                                            });
                                            $('#myModal').modal('show');
                                        } else {
                                            this.saveInfo(info);
                                        }
                                    })
                                }
                            });
                        } else {

                            $('#myModal').modal({
                                backdrop: 'static',
                                keyboard: false  // to prevent closing with Esc button (if you want this too)
                            });
                            $('#myModal').modal('show');
                        }
                    }
                })
            });
    }

    timeOurtReset() {
        this.idle.watch();
        this.idleState = 'Started.';
        this.timedOut = false;
    }

    logintest() {
        if (this.loginInfo == "Hello") {
            $('#myModal').modal("hide");
            return
        }
        this.authenticationService.newLogin(this.model.username, this.model.password, '')
            .subscribe(
                mydata => {
                    let info = mydata._body;
                    if (info.indexOf('ERROR') > -1) {
                        let message = info.split(":");
                        this.loginFailResponse = message[1];
                    } else {
                        this.saveInfo(info);
                    }
                },
                error => {

                    console.log(error);
                });
    }

    saveInfo(info) {
        let data = JSON.parse(info);
        console.log("Data:")
        console.log(data)
        let customerId = data.CUSTOMER_ID;
        let customerName = data.DISPLAY_NAME
        let companyName = data.COMPANY_NAME;
        let companyId = data.COMPANY_ID;
        this.cartCount = data.CART_ORDERS;
        this.saleName = data.SALES_REP;
        this.saleEmail = data.SALES_REP_EMAIL;
        this.sessionKey = data.WEB_SESSION_ID;
        this.invoiceStatus = data.INVOICE;
        this.invoiceOnly = data.INVOICE_ONLY;
        let tcheckedStatus = data.TOS_CHECKED;
        let altEmail = data.ALTERNATE_EMAIL;
        let altInvoice = data.ALTERNATE_INVOICE;
        let bulkLoad = data.BULK_LOAD;
        let allowClientBatch=data.CLIENT_ALLOW_BATCH;
        let prescreen = data.PRESCREEN;
        let manageMsg = data.MANAGE_MSG;
        let contractor = data.CONTRACTOR;
        let orderPin = data.ORDER_PIN;
        let loginCountry = data.COUNTRY || "";
        console.log("Bulk Load:")
        console.log(bulkLoad)
        console.log("prescreen:")
        console.log(prescreen)
        if (((data.CUSTOMER_ID != "null") && (data.CUSTOMER_ID != null)) && (!data.MESSAGE)) {
            this.cookieService.clearAll();
            this.cookieService.setCookieSession("customerID", customerId);
            this.cookieService.setCookieSession("customerName", customerName);
            this.cookieService.setCookieSession("companyName", companyName);
            this.cookieService.setCookieSession("companyId", companyId);
            this.cookieService.setCookieSession("cartCount", this.cartCount);
            this.cookieService.setCookieSession("saleName", this.saleName);
            this.cookieService.setCookieSession("saleEmail", this.saleEmail);
            this.cookieService.setCookieSession("sessionKey", this.sessionKey);
            this.cookieService.setCookieSession("invoiceStatus", this.invoiceStatus);
            this.cookieService.setCookieSession("invoiceOnly", this.invoiceOnly);
            this.cookieService.setCookieSession("tchecked", tcheckedStatus);
            this.cookieService.setCookieSession("altEmail", altEmail);
            this.cookieService.setCookieSession("altInvoice", altInvoice);
            this.cookieService.setCookieSession("bulkLoad", bulkLoad);
            this.cookieService.setCookieSession("allowClientBatch", allowClientBatch);
            this.cookieService.setCookieSession("manageMsg", manageMsg);
            this.cookieService.setCookieSession("prescreen", prescreen);
            this.cookieService.setCookieSession("contractor", contractor);
            this.cookieService.setCookieSession("orderPin", orderPin);
            this.cookieService.setCookieSession("loginCountry", loginCountry);
            $('#myModal').modal("hide"); //add delay
            this.loginInfo = "Hello";
            this.userInfo = customerName;
            this.allowBulk = bulkLoad
            this.allowMsg = manageMsg
            this.loginResponse = data.RESPONSE_MSG;
            this.timeOurtReset();
            this.ngZone.runOutsideAngular(() => {
                location.reload();
            });
        } else {
            this.loginFailResponse = "Failed";
        }
        
    }

    ngOnInit() {
        this.route.queryParams.subscribe(params => {
            this.model.username = params.u;
        }
        );
        if (this.cookieService.getCookie('customerName')) {
            this.userInfo = this.cookieService.getCookie('customerName');
            this.allowBulk = this.cookieService.getCookie('bulkLoad');
            this.allowMsg = this.cookieService.getCookie('manageMsg');
            this.loginInfo = "Hello";
        }

        if ((this.cookieService.getCookie('saleName')) && (this.cookieService.getCookie('saleEmail'))) {
            this.saleName = this.cookieService.getCookie('saleName');
            this.saleEmail = this.cookieService.getCookie('saleEmail');
        } else {
            this.saleName = null;
            this.saleEmail = null;
        }
        this.intro = this.introService.introJS();

        fetch('/assets/notification.html').then(res => res.text()).then(data => {
            this.infoContent = this.sanitizer.bypassSecurityTrustHtml(data);
          })

    }

    logout() {

        let customerid = this.cookieService.getCookie("customerID");
        let sessionKey = this.cookieService.getCookie("sessionKey");
        this.authenticationService.logout(customerid, sessionKey).subscribe(data => console.log("logOut"));
        this.cookieService.deleteCookie('customerID');
        this.cookieService.deleteCookie("customerName");
        this.cookieService.deleteCookie("ccompanyName");
        this.cookieService.deleteCookie("companyId");
        this.cookieService.deleteCookie('saleEmail');
        this.cookieService.deleteCookie("saleName");
        this.cookieService.deleteCookie("invoiceStatus");
        this.cookieService.deleteCookie("invoiceOnly");
        this.cookieService.deleteCookie('qid');
        this.cookieService.deleteCookie("bucket");
        this.cookieService.deleteCookie("tchecked");
        this.cookieService.deleteCookie("altEmail");
        this.cookieService.deleteCookie("altInvoice");
        this.cookieService.deleteCookie("prescreen");
        this.cookieService.deleteCookie("contractor");
        this.cookieService.deleteCookie("orderPin");
        this.cookieService.deleteCookie("loginCountry");
        this.cookieService.clearAll();
    }

    resetOrder() {
        this.cookieService.clearAll();
    }

    register() {
        window.location.href = '/register/';
    }

    showHelp() {

        this.intro.oncomplete(function () {
            window['introSlide'] = 0;
        });

        this.intro.onchange(function (targetElement) {
            window['introSlide'] = this._currentStep;
        });

        let step = window['introSlide'];
        window['introJS'] = this.intro;

        if (step === null || step === undefined || step == 0) this.intro.start();
        else this.intro.goToStep(step).start();
        return false;
    }

    sendPassword() {
        this.passwordService.emailpassword(this.model.username)
            .subscribe(
                response => {
                    this.forgotPasswordResponse = response;
                },
                error => {
                    console.log(error);
                });
    }

    showChangePassword() {
        $('#changePasswordModal').modal("show");
        return false;
    }

    showManageMsg() {
        this.curNewMsg = "";
        $('#changeMsgModal').modal("show");
        return false;
    }

    submitNewMsg() {
        let encoding = btoa(this.curNewMsg);
        let inputJson = {
            "htmlcontent": encoding
        }
        this.messageUploadService.serviceCall(JSON.stringify(inputJson)).subscribe((res) => {
            console.log(res);
            $('#changeMsgModal').modal("hide");
        })

    }

    copyUp() {
        this.curNewMsg = this.sampleMsg;
    }

    changePassword() {
        if (!this.cookieService.getCookie("customerID")) return false;
        if (this.newPassword !== this.newPassword2) this.changePasswordResponse = "The passwords do not match.";
        else this.changePasswordResponse = "";

        let customerID = this.cookieService.getCookie('customerID');

        let sessionKey = this.cookieService.getCookie("sessionKey");
        this.passwordService.changepassword(customerID, this.model.password, this.newPassword, sessionKey)
            .subscribe(
                response => {

                    this.changePasswordSuccess = response;
                },
                error => {
                    console.log(error);
                });
    }

    detectIE() {
        let ua = window.navigator.userAgent;

        // Test values; Uncomment to check result �

        // IE 10
        // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';

        // IE 11
        // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';

        // IE 12 / Spartan
        // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';

        // Edge (IE 12+)
        // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

        let msie = ua.indexOf('MSIE ');
        if (msie > 0) {
            // IE 10 or older => return version number
            return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
        }

        let trident = ua.indexOf('Trident/');
        if (trident > 0) {
            // IE 11 => return version number
            let rv = ua.indexOf('rv:');
            return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
        }

        let edge = ua.indexOf('Edge/');
        if (edge > 0) {
            // Edge (IE 12+) => return version number
            return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
        }

        // other browser
        return false;
    }
}
